import { getServiceName } from './serviceName';

const _CONTAINERS: Record<string, HTMLElement> = {};
// Храним в памяти react'овые ноды, т.к. они перетираются рендером до unmount'а, и destroy валится
const _REACT_ROOTS: Record<string, HTMLElement> = {};

const capitalize = (str: string) => str[0].toUpperCase() + str.slice(1);

export const saveContainer = (rootNode: HTMLElement, identifier: string): void => {
    _CONTAINERS[identifier] = rootNode;
};

export const removeContainer = (identifier: string): void => {
    delete _CONTAINERS[identifier];
};

export const getContainer = (identifier: string): HTMLElement => {
    return _CONTAINERS[identifier];
};

export const findReactRoot = (identifier: string): HTMLElement | null =>
    getContainer(identifier)?.querySelector(`.${capitalize(getServiceName())}-ReactRoot`);

export const saveReactRoot = (reactRootNode: HTMLElement, identifier: string): void => {
    _REACT_ROOTS[identifier] = reactRootNode;
};

export const removeReactRoot = (identifier: string): void => {
    delete _REACT_ROOTS[identifier];
};

export const getReactStateNode = (identifier: string): HTMLTemplateElement | null =>
    getContainer(identifier)?.querySelector(`.${capitalize(getServiceName())}-InitialState`);

export default getContainer;
